import React from 'react'
import { StyleSheet, Text, View } from "@react-pdf/renderer";
const styles = StyleSheet.create({
    footer: {
        height: 50,
        marginTop: 20,
        color: '#ccc',
        textAlign: 'center',
    },
});
const Footer = () => {
    return (
        <View style={styles.footer}>
            <Text>If you face any problems while planning your event, you may contact our customer support at +918188088879</Text>
            <Text>
                Powered by Event Planet 2026Free Consultation with a Wedding Expert
            </Text>
        </View>
    )
}

export default Footer